import React, { Fragment, useEffect, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import TitleH4Component from "../../components/TitleH4Component";
import { Icon } from "@iconify/react/dist/iconify.js";
import stylebtn from "../../styles/btn.module.scss";
import { Link, useParams } from "react-router-dom";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import ParrafoComponent from "../../components/ParrafoComponent";
import stylegeneral from "../../styles/general.module.scss";
import {
  obtenerDetalleFactura,
  PostAbonoFactura,
  ActualizarAbono,
  EliminarAbono,
  Editarfactura,
} from "../../api/Factura";
import LoaderComponent from "../../components/LoaderComponent";
import ModalAbono from "../../components/ModalAbono";
import MoneyInputComponent from "../../components/MoneyInputComponent";
import { useFormatter } from "../../hooks/useFormatter";
import { useEstadoFactura } from "../../hooks/useEstadoFactura";
import { useAuth } from "../../context/AuthContext";
import AlertComponent from "../../components/AlertComponent";
import { abrirPdfVentas } from "../../api/Pdf";
import BotonWhatsappPdfComponent from "../../components/BotonWhatsappPdfComponent";
import { compartirFacturaWhatsApp } from "../../helpers/compartirDocumentoWhatsApp";

const DetalleFacturaPage = () => {
  const { id } = useParams();
  const [showAbono, setABono] = useState(false);

  const [loading, setLoading] = useState(false);
  const [currentFactura, setCurrentFactura] = useState([]);
  const [idFactura, setIdFactura] = useState("");
  const [data, setData] = useState([]);
  //const [estado, setEstado] = useState(2);
  const [dataAbono, setDataAbono] = useState([]);
  const [totalAbonos, setTotalAbono] = useState(0);
  const [pendienteEntrega, setPendienteEntrega] = useState(0);
  const { formatDate, formatDateUTC } = useFormatter();
  const { isAdmin, idUser, isSuper } = useAuth();
  //Para la modal de registo de abono
  const [showRestroA, setRegistroA] = useState(false);

  const [abono, setAbono] = useState(0);

  const [mensaje, setMensaje] = useState("");
  const [alert, setAlert] = useState(false);
  const [descripcionAbono, setDescripcionAbono] = useState("");

  const handleCloseAbono = () => {
    fetchFactura();
    setABono(false);
  };

  const handleChangeDescripcion = (event) => {
    setDescripcionAbono(event.target.value);
  };



  useEffect(() => {
    // Calculamos el total de los pendiente por entregar
    const calcularProductoPendiente = data.reduce((acc, item) => {
      return acc + (item?.pendientePorEntregar || 0);
    }, 0);
    setPendienteEntrega(calcularProductoPendiente);
  }, [data]);

  const handleAbono = () => setABono(true);
  const handleClose = () => setABono(false);

  const handleShowRegistroA = () => {
    //fetchAbonoNomina();
    setRegistroA(true);
  };

  const handleCloseRegistroA = () => setRegistroA(false);

  const fetchFactura = async () => {
    setLoading(true);
    try {
      const factura = await obtenerDetalleFactura(id);
      setCurrentFactura(factura?.data);
      setIdFactura(factura?.data?.id);

      const formattedData = (factura?.data?.DetalleFacturas || []).map(
        (item) => ({
          ...item,

          formattedDate: formatDate(item.createdAt),
        }),
      );
      setData(formattedData);

      const formattedDataAbono = factura?.data?.Abonos?.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      ) // 👈 orden descendente
        ?.map((item) => ({
          ...item,
          formattedDate: formatDateUTC(item.createdAt),
          formattedPrice: Number(item.monto).toLocaleString("es-ES"),
        }));

      setDataAbono(formattedDataAbono);
      // Sumar los montos
      const totalMontos = factura?.data?.Abonos?.reduce((total, item) => {
        return total + Number(item.monto);
      }, 0);

      setTotalAbono(totalMontos);
      let estado;
      //Logica para cambiar de estado a la factura segun el caso 
      if (factura && factura?.data?.DetalleFacturas.length > 0) {
        const pendientes = factura?.data?.DetalleFacturas.some(
          item => item.pendientePorEntregar > 0
        );

        const totalFactura = Number(factura.data.total) + Number(factura.data.transporte) - Number(factura?.data?.descuento);
        const totalAbonado = Number(totalMontos);
        const financiado = Number(factura.data.financiado);

        // Actualizar la factura si los montos coinciden
        if (totalFactura !== totalAbonado && financiado > 0) {
          estado = 1;
        } else if (pendientes) {
          estado = 2;
        } else {
          estado = 0;
        }

        await Editarfactura(
          factura?.data?.id,
          factura?.data.id_user,
          estado,
          factura?.data?.subtotal,
          factura?.data?.fechaDePago,
          factura?.data?.descuento,
          factura?.data?.financiado,
          factura?.data?.total,
          factura?.data?.transporte,
          factura?.data?.tipo,
          factura?.data?.quien_recibe,
          factura?.data?.direccion,
          factura?.data?.nombre_conductor,
          factura?.data?.celular_conductor,
          factura?.data?.fecha_creacion
        );

        // Actualiza el estado de currentFactura localmente
        setCurrentFactura((prevFactura) => ({
          ...prevFactura,
          estado,
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFactura();
    }
  }, [id, totalAbonos]);

  const handleInputChangeFactura = (event) => {
    setAbono(event.target.value);
  };


  //ESTO QUEDA PENDIENTE PARA MAÑANA O MAS TARDE
  const crearAbonoFactura = async () => {
    try {
      if (abono != 0) {
        const res = await PostAbonoFactura(idFactura, abono, descripcionAbono, idUser);
        if (res.success) {
          setAlert(true);
          setMensaje(res.msg);
          fetchFactura();
          handleCloseAbono();
          setDescripcionAbono("");
          setAbono("")
        }
      } else {
        setMensaje("Cantidad incorrecta");
      }
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setAlert(false);
      setMensaje("");
    }, 3000);
  };

  const editarAbonoFactura = async (obj, monto) => {
    try {
      const res = await ActualizarAbono(obj?.id, monto);
      if (res?.success) {
        setMensaje(res?.msg);
        fetchFactura();
      }
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setMensaje("");
    }, 3000);
  };

  const eliminarAbonoFactura = async (obj) => {
    try {
      const res = await EliminarAbono(obj?.id);
      if (res?.success) {
        setMensaje(res?.msg);
        fetchFactura();
      }
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setMensaje("");
    }, 3000);
  };

  // Estado de la factura/cotización (Cerrada/Abierta/Pendiente/Vencida)
  const { calcularEstadoFactura } = useEstadoFactura();
  const estadoInfo = calcularEstadoFactura({
    estado: currentFactura?.estado,
    fechaVencimiento: currentFactura?.fechaDePago,
    tipo: currentFactura?.tipo === "cotizacion" ? "cotizacion" : "venta",
  });
  const handleGoBack = () => {
    //Retrocede una página en el historial
    window.history.back();
  };

  const generarPdf = async () => {
    await abrirPdfVentas(currentFactura?.id);
  }

  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <AlertComponent
          styleGroup="bg-soccess color-white"
          mensaje={mensaje}
          activaalert={alert}
        />
      </div>
      <HeaderComponent>
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          DETALLE{" "}
          {currentFactura?.tipo === "cotizacion" ? "COTIZACION" : "FACTURA"}
        </TitleH2Component>
        {(currentFactura?.tipo === "cotizacion" ||
          (currentFactura?.tipo === "venta" && currentFactura?.estado != 0) ||
          (currentFactura?.estado === 0 && isSuper)) && (
            <Link
              to={`/editar-factura-venta/${currentFactura?.id}`}
              className={`${stylebtn.btn} ${stylebtn.primary} ${isAdmin || (!isAdmin && currentFactura?.tipo !== "venta")
                  ? ""
                  : "d-none"
                }`}
            >
              EDITAR {currentFactura?.tipo === "venta" ? "FACTURA" : "COTIZACION"}
            </Link>
          )}
      </HeaderComponent>
      {loading ? (
        <LoaderComponent styleGroup="mt-5" />
      ) : (
        <div className="conatiner-global pt-3 mb-5">
          <section>
            <div className="container-fluid">
              <div className="row gy-4">
                <div className="col-12 col-md-6 col-xl-4">
                  <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                    {currentFactura?.Cliente?.Persona?.nombre}{" "}
                    {currentFactura?.Cliente?.Persona?.apellido}
                  </TitleH2Component>
                  <TitleH4Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                    C.C: {currentFactura?.Cliente?.Persona?.cedula}
                  </TitleH4Component>

                  {currentFactura?.quien_recibe && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto mb-1 text-center">
                      <span className="color-dark">Quien recibe:</span>{" "}
                      <span className="color-madera">
                        {currentFactura?.quien_recibe}
                      </span>
                    </ParrafoComponent>
                  )}

                  <ParrafoComponent styleGroup="box-text fw700 roboto mb-1 text-center">
                    <span className="color-dark me-2">Vendedor:</span>
                    <span className="color-madera">
                      {currentFactura?.User?.nombre || "Sin nombre"}
                    </span>
                  </ParrafoComponent>
                </div>
                <div
                  className={` ${currentFactura?.tipo === "cotizacion" ? "no_visible" : ""} col-12 col-md-6 col-xl-4`}
                >
                  <TitleH2Component
                    styleGroup={`
                     ${estadoInfo?.className || ""}
                     box-text color-dark fw700 roboto mb-1 text-center
                    `}
                  >
                    {estadoInfo?.text || ""}
                  </TitleH2Component>
                </div>
                <div className="col-12 col-md-6 col-xl-4">
                  <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                    {new Date(currentFactura?.createdAt).toLocaleDateString()}
                  </TitleH2Component>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="d-flex justify-content-end flex-column align-items-end">
              <button
                type="button"
                onClick={handleGoBack}
                className={`${stylebtn.btn_desnudo} ${stylebtn.icon} mb-3 p-0 d-inline-flex color-dark`}
              >
                <Icon icon="icon-park-solid:back" />
              </button>

              <button
                onClick={handleAbono}
                className={`${stylebtn.btn_desnudo} ${stylebtn.icon} mb-3 p-0 d-inline-flex color-black`}
                disabled={
                  currentFactura?.estado === 0 ||
                  currentFactura?.estado === 2 ||
                  currentFactura?.tipo === "cotizacion"
                } // Deshabilita si el estado es 'Cerrada'
              >
                <Icon icon="solar:hand-money-linear" />
              </button>

              {currentFactura?.tipo === "venta" && (
                <Link
                  to={currentFactura?.estado !== 0 ? `/carrito/${id}` : "#"} // Deshabilita el enlace si la factura está cerrada
                  className={`${stylebtn.btn} ${stylebtn.primary} link mb-3 
                                        ${currentFactura?.estado === 0
                      ? "btn-disabled"
                      : ""
                    }`}
                  onClick={(e) =>
                    currentFactura?.estado === 0 && e.preventDefault()
                  } // Evita la acción si está deshabilitado
                >
                  DESPACHAR
                </Link>
              )}
              <button
                //  to={`/generarfactura/${currentFactura?.id}`}
                type="button"
                onClick={generarPdf}
                className={`${stylebtn.btn} ${stylebtn.primary}`}
              >
                GENERAR FACTURA
              </button>
              <BotonWhatsappPdfComponent
                onClick={() => compartirFacturaWhatsApp(currentFactura)}
                disabled={!currentFactura?.id}
                styleGroup="mt-2"
              />
            </div>
          </section>
          <section>
            <div className="table-responsive mt-4">
              <ParrafoComponent styleGroup=" color-dark fw400 WorkSans fw700">
                N° Factura: {currentFactura?.numeroFactura}
              </ParrafoComponent>

              <table className="table table-bordered tableGeneral">
                <thead>
                  <tr>
                    <th scope="col" className="color-madera">
                      Bloque/Puesto
                    </th>
                    {currentFactura?.tipo === "venta" && (
                      <th scope="col" className="color-madera">
                        Pend. Entrega
                      </th>
                    )}
                    {currentFactura?.tipo === "venta" && (
                      <th scope="col" className="color-madera">
                        Entregados
                      </th>
                    )}
                    <th scope="col" className="color-madera">
                      Cantidad producto
                    </th>
                    <th scope="col" className="color-madera">
                      Descripción
                    </th>
                    <th scope="col" className="color-madera">
                      Valor por Unidad
                    </th>
                    <th
                      scope="col"
                      colSpan={currentFactura?.tipo === "venta" ? "" : 3}
                      className="color-madera"
                    >
                      Valor Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    return (
                      <tr key={index}>
                        <th>
                          B{item?.Producto?.Puesto?.Bloque?.name}/ P
                          {item?.Producto?.Puesto?.numero}
                        </th>
                        {currentFactura?.tipo === "venta" && (
                          <th>{item?.pendientePorEntregar}</th>
                        )}
                        {currentFactura?.tipo === "venta" && (
                          <th>{item?.cantidad}</th>
                        )}
                        <th>{item?.cantidad + item?.pendientePorEntregar}</th>
                        <td>
                          {item?.Producto?.Tipo?.name} {""}
                          {item?.Producto?.Clase?.name} {""}
                          {item?.Producto?.dimension}
                        </td>
                        <td>
                          ${" "}
                          {Number(item?.valorPorUnidad).toLocaleString("es-ES")}
                        </td>
                        <td colSpan={currentFactura?.tipo === "venta" ? "" : 3}>
                          ${" "}
                          {Number(
                            item?.valorPorUnidad *
                            (item?.cantidad + item?.pendientePorEntregar),
                          ).toLocaleString("es-ES")}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {/**Tabla resumen de la factura alineada a la derecha*/}
              <div className="d-flex justify-content-end mt-0">
                <table
                  className="table table-bordered tableGeneral"
                  style={{ width: "auto", minWidth: "350px" }}
                >
                  <tbody>
                    <tr>
                      <td className="text-right fw600">SUBTOTAL</td>
                      <td>
                        ${" "}
                        {Number(currentFactura?.subtotal).toLocaleString(
                          "es-ES",
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right fw600">DESCUENTO</td>
                      <td>
                        ${" "}
                        {Number(currentFactura?.descuento).toLocaleString(
                          "es-ES",
                        )}
                      </td>
                    </tr>
                    {currentFactura?.tipo === "venta" && (
                      <tr>
                        <td className="text-right fw600"> PENDIENTE DE PAGO</td>
                        <td>
                          ${" "}
                          {Number(currentFactura.financiado) === 0
                            ? 0
                            : (
                              Number(currentFactura?.total) +
                              Number(currentFactura?.transporte) -
                              totalAbonos -
                              currentFactura?.descuento
                            ).toLocaleString("es-ES")}
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td className="text-right fw600">TRANSPORTE</td>
                      <td>
                        ${" "}
                        {Number(currentFactura?.transporte).toLocaleString(
                          "es-ES",
                        )}
                      </td>
                    </tr>

                    {currentFactura?.tipo === "venta" && (
                      <tr>
                        <td className="text-right fw600">ABONO</td>
                        <td
                          onClick={handleShowRegistroA}
                          className="hover-pointer"
                        >
                          $ {Number(totalAbonos).toLocaleString("es-ES")}
                        </td>
                      </tr>
                    )}
                    {currentFactura?.tipo === "venta" && (
                      <tr>
                        <td className="text-right fw600">
                          PENDIENTE POR ENTREGA
                        </td>
                        <td>{pendienteEntrega}</td>
                      </tr>
                    )}
                    {currentFactura?.tipo === "venta" && (
                      <tr>
                        <td className="text-right fw600">TOTAL CANCELADO</td>
                        <td
                          style={{
                            backgroundColor: "silver",
                            fontWeight: "bold",
                          }}
                        >
                          ${Number(totalAbonos).toLocaleString("es-ES")}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td className="text-right fw600">TOTAL</td>
                      <td
                        style={{
                          backgroundColor: "lightgreen",
                          fontWeight: "bold",
                        }}
                      >
                        ${" "}
                        {(
                          Number(currentFactura?.total) +
                          Number(currentFactura?.transporte) -
                          Number(currentFactura?.descuento)
                        ).toLocaleString("es-ES")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
          {/** Modal para abonar*/}
          <section>
            <ModalGeneralComponent
              styleGroup="d-flex align-items-center modal-general "
              styleTitle={
                "box-text color-madera fw700 roboto text-center WorkSans"
              }
              data={dataAbono ?? []}
              show={showAbono}
              handleClose={handleClose}
            >
              <div className="container">
                <form action="">
                  <div className="d-flex align-items-start justify-content-between">
                    <div>
                      <TitleH4Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                        {currentFactura?.Cliente?.Persona?.nombre}
                      </TitleH4Component>
                      <ParrafoComponent styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                        {currentFactura?.Cliente?.Persona?.apellido}
                      </ParrafoComponent>
                      <ParrafoComponent styleGroup="box-text color-dark fw700 roboto mb-3 text-center">
                        CC: {currentFactura?.Cliente?.Persona?.cedula}
                      </ParrafoComponent>
                    </div>
                    <TitleH4Component styleGroup="mb-0 me-3">
                      {new Date(currentFactura?.createdAt).toLocaleDateString()}
                    </TitleH4Component>
                  </div>
                  <div className="mb-4">
                    <MoneyInputComponent
                      label="PAGAR"
                      styleLabel="fw600 WorkSans"
                      styleGroup={`${stylegeneral.col}`}
                      //htmlFor="abono"
                      value={abono} // Asegúrate de pasar el valor correcto aquí
                      name="abono"
                      onChange={handleInputChangeFactura}
                    />
                    <textarea
                      label="descripcion"
                      name="descripcionAbono"
                      placeholder="Descripción"
                      className="form-control mt-3"
                      rows={3}
                      value={descripcionAbono}
                      onChange={handleChangeDescripcion}
                    ></textarea>
                  </div>

                  <div className="d-flex w-100 justify-content-end aling-items-start">
                    <div className=" mt-4">
                      <button
                        type="button"
                        className={` ${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3 `}
                        onClick={handleClose}
                      >
                        CANCELAR
                      </button>
                      <button
                        onClick={crearAbonoFactura}
                        type="button"
                        className={`btn ${stylebtn.btn} ${stylebtn.primary} `}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </ModalGeneralComponent>
          </section>
        </div>
      )}

      {/**Modal Ver Registro de Abonos */}
      <ModalAbono
        mensaje={mensaje}
        show={showRestroA}
        handleClose={handleCloseRegistroA}
        data={dataAbono}
        editarAbono={editarAbonoFactura}
        eliminarAbono={eliminarAbonoFactura}
      />
    </Fragment>
  );
};

export default DetalleFacturaPage;
